<template>
  <div class="mytask">
    <div class="page-title">
      <div class="page-title-wrap">
        <div>任务中心</div>
        <div class="search-wrap">
          <input class="icon-text" type="test" v-model="search_value" placeholder="请输入需求名称">
          <i class="icon-serch" @click="handleSearch"></i>
        </div>
      </div>
    </div>
    <div class="nav-tabpanel-box">
      <div :class="['item-nav-box', selTabIndex == 1301 ? 'active' : '']" @click="handleSelTab(1301)">
        可投标任务
      </div>
      <div :class="['item-nav-box', selTabIndex == 9999 ? 'active' : '']" @click="handleSelTab(9999)">
        全部任务
      </div>
      <div :class="['item-nav-box', selTabIndex == 1111 ? 'active' : '']" @click="handleSelTab(1111)">
        宣传任务
      </div>
      <div :class="['item-nav-box', selTabIndex == 2222 ? 'active' : '']" @click="handleSelTab(2222)">
        征集需求
      </div>
      <div :class="['item-nav-box', selTabIndex == 3333 ? 'active' : '']" @click="handleSelTab(3333)">
        UI需求
      </div>
      <div :class="['item-nav-box', selTabIndex == 4444 ? 'active' : '']" @click="handleSelTab(4444)">
        测试需求
      </div>
    </div>
    <template v-if="selTabIndex == 1301">
      <div class="table-header-box cell-row">
        <div class="cell-column tasktype-cell">任务名称</div>
        <div class="cell-column projecttype-cell">项目状态</div>
        <div class="cell-column project-yusuan-cell">H5页面数</div>
        <div class="cell-column task-publishtime-cell">发布时间</div>
        <div class="cell-column task-days-cell">截止时间</div>
        <div class="cell-column operate-cell">操作</div>
      </div>
      <div class="table-list-box" v-infinite-scroll="loadMoreData" :infinite-scroll-disabled="disabledLoadMore">
        <template v-if="taskList.length">
          <div v-for="(item, idx) in taskList" :key="idx" class="datalist-row cell-row">
            <div class="cell-column tasktype-cell">
              {{ item.mid_table_remark_001}}
            </div>
            <div
              class="cell-column projecttype-cell"
              :class="{'1301':'ongoing','1302':'getoffer','1303':'finish'}[item.mid_table_remark_013]"
            >
              {{ item.mid_table_remark_013 == 1301 ? "发包中" : (item.mid_table_remark_013 == 1302 ? "已接包" : "已完成") }}
            </div>
            <div class="cell-column project-yusuan-cell">
              {{ item.mid_table_remark_016||'暂无' }}
              <span v-if="item.mid_table_remark_016"> 张</span>
            </div>
            <div class="cell-column task-publishtime-cell">
              {{ item.time_insert|showTime }}
            </div>
            <div class="cell-column task-days-cell">
              {{ getDays(item) }}
            </div>
            <div class="cell-column operate-cell">
              <div @click="toTaskDetail(item)">查看详情
              </div>
            </div>
          </div>
        </template>
        <NoneData v-else></NoneData>
      </div>
    </template>
    <template v-else-if="selTabIndex == 9999">
      <div class="table-header-box cell-row">
        <div class="cell-column taskname-cell">任务名称</div>
        <div class="cell-column taskpost-cell">项目发包方</div>
        <div class="cell-column tasktime-cell">发布时间</div>
        <div class="cell-column taskstatus-cell">项目状态</div>
      </div>
      <div class="table-list-box" v-infinite-scroll="loadMoreData" :infinite-scroll-disabled="disabledLoadMore">
        <template v-if="taskList.length">
          <div v-for="(item, idx) in taskList" :key="idx" class="datalist-row cell-row">
            <div class="cell-column taskname-cell">
              {{ item.mid_table_remark_001}}
            </div>
            <div class="cell-column taskpost-cell">
              {{ item.mid_table_remark_014 }}
            </div>
            <div class="cell-column tasktime-cell">
              {{item.time_insert }}
            </div>
            <div
              class="cell-column taskstatus-cell"
              :class="{'1301':'ongoing','1302':'getoffer','1303':'pushoffer','1303':'finish'}[item.mid_table_remark_013]"
            >
              {{ item.mid_table_remark_013 == 1301 ? "发包中" : (item.mid_table_remark_013 == 1302 ? "已接包" : (item.mid_table_remark_013 == 1304 ? "已提包" : "已完成")) }}
            </div>
          </div>
        </template>
        <NoneData v-else></NoneData>
      </div>
    </template>
    <template v-else-if="selTabIndex == 1111">
      <div class="table-header-box cell-row">
        <div class="cell-column tasktype-cell">任务名称</div>
        <div class="cell-column project-yusuan-cell">任务状态</div>
        <div class="cell-column project-yusuan-cell">报价范围</div>
        <div class="cell-column task-publishtime-cell">发布时间</div>
        <div class="cell-column task-publishtime-cell">截止时间</div>
        <div class="cell-column operate-cell">操作</div>
      </div>
      <div class="table-list-box" v-infinite-scroll="loadMoreData" :infinite-scroll-disabled="disabledLoadMore">
        <template v-if="taskList.length">
          <div v-for="(item, idx) in taskList" :key="idx" class="datalist-row cell-row">
            <div class="cell-column tasktype-cell">
              {{ item.mid_table_remark_001}}
            </div>
            <div
              class="cell-column project-yusuan-cell"
              :class="{'2001':'ongoing','2002':'getoffer','2003':'finish'}[item.mid_table_remark_002]"
            >
              {{ item.mid_table_remark_002 == 2001 ? "发布中" : (item.mid_table_remark_002 == 2002 ? "已接单" : "已完成") }}
            </div>
            <div class="cell-column project-yusuan-cell">
              <span v-if="item.mid_table_remark_010">{{ item.mid_table_remark_010.replace(/-_-/g, " ~ ") }}</span>
              <span v-else>--</span>
            </div>
            <div class="cell-column task-publishtime-cell">
              {{ item.time_insert|showTime }}
            </div>
            <div class="cell-column task-publishtime-cell">
              {{ item.time_4_end|showTime  }}
            </div>
            <div class="cell-column operate-cell">
              <div @click="toPublicityDetail(item)">查看详情
              </div>
            </div>
          </div>
        </template>
        <NoneData v-else></NoneData>
      </div>
    </template>
    <template v-else-if="selTabIndex == 2222">
      <div class="table-header-box cell-row">
        <div class="cell-column tasktype-cell">征集需求名称</div>
        <div class="cell-column project-yusuan-cell">需求状态</div>
        <div class="cell-column project-yusuan-cell">H5页面数量</div>
        <div class="cell-column task-publishtime-cell">发布时间</div>
        <div class="cell-column task-publishtime-cell">截止时间</div>
        <div class="cell-column operate-cell">操作</div>
      </div>
      <div class="table-list-box" v-infinite-scroll="loadMoreData" :infinite-scroll-disabled="disabledLoadMore">
        <template v-if="taskList.length">
          <div v-for="(item, idx) in taskList" :key="idx" class="datalist-row cell-row">
            <div class="cell-column tasktype-cell">
              {{ item.mid_table_remark_001}}
            </div>
            <div
              class="cell-column project-yusuan-cell"
              :class="{'2001':'ongoing','2002':'getoffer','2003':'finish'}[item.mid_table_remark_020]"
            >
              {{ item.mid_table_remark_020 == 2001 ? "发布中" : (item.mid_table_remark_020 == 2002 ? "已接单" : "已完成") }}
            </div>
            <div class="cell-column project-yusuan-cell">
              <span v-if="item.mid_table_remark_004">{{ item.mid_table_remark_004 }}</span>
              <span v-else>--</span>
            </div>
            <div class="cell-column task-publishtime-cell">
              {{ item.time_insert|showTime }}
            </div>
            <div class="cell-column task-publishtime-cell">
              {{ item.time_4_end|showTime  }}
            </div>
            <div class="cell-column operate-cell">
              <div @click="toDemandCollectDetail(item)">查看详情
              </div>
            </div>
          </div>
        </template>
        <NoneData v-else></NoneData>
      </div>
    </template>
    <template v-else-if="selTabIndex == 3333">
      <div class="table-header-box cell-row">
        <div class="cell-column tasktype-cell">征集需求名称</div>
        <div class="cell-column project-yusuan-cell">需求状态</div>
        <div class="cell-column project-yusuan-cell">草图数量</div>
        <div class="cell-column task-publishtime-cell">发布时间</div>
        <div class="cell-column task-publishtime-cell">截止时间</div>
        <div class="cell-column operate-cell">操作</div>
      </div>
      <div class="table-list-box" v-infinite-scroll="loadMoreData" :infinite-scroll-disabled="disabledLoadMore">
        <template v-if="taskList.length">
          <div v-for="(item, idx) in taskList" :key="idx" class="datalist-row cell-row">
            <div class="cell-column tasktype-cell">
              {{ item.mid_table_remark_001}}
            </div>
            <div
              class="cell-column project-yusuan-cell"
              :class="{'7001':'ongoing','7002':'getoffer','7003':'finish'}[item.mid_table_remark_007]"
            >
              {{ item.mid_table_remark_007 == 7001 ? "发布中" : (item.mid_table_remark_007 == 7002 ? "已接单" : "已完成") }}
            </div>
            <div class="cell-column project-yusuan-cell">
              <span v-if="item.mid_table_remark_004">{{ item.mid_table_remark_004 }}</span>
              <span v-else>--</span>
            </div>
            <div class="cell-column task-publishtime-cell">
              {{ item.time_insert|showTime }}
            </div>
            <div class="cell-column task-publishtime-cell">
              {{ item.time_4_end|showTime  }}
            </div>
            <div class="cell-column operate-cell">
              <div @click="toUIDemandDetail(item)">查看详情
              </div>
            </div>
          </div>
        </template>
        <NoneData v-else></NoneData>
      </div>
    </template>
    <template v-else-if="selTabIndex == 4444">
      <div class="table-header-box cell-row">
        <div class="cell-column tasktype-cell">测试需求名称</div>
        <div class="cell-column project-yusuan-cell">需求状态</div>
        <div class="cell-column project-yusuan-cell">测试页面数量</div>
        <div class="cell-column task-publishtime-cell">发布时间</div>
        <div class="cell-column task-publishtime-cell">截止时间</div>
        <div class="cell-column operate-cell">操作</div>
      </div>
      <div class="table-list-box" v-infinite-scroll="loadMoreData" :infinite-scroll-disabled="disabledLoadMore">
        <template v-if="taskList.length">
          <div v-for="(item, idx) in taskList" :key="idx" class="datalist-row cell-row">
            <div class="cell-column tasktype-cell">
              {{ item.mid_table_remark_001}}
            </div>
            <div
              class="cell-column project-yusuan-cell"
              :class="{'7001':'ongoing','7002':'getoffer','7003':'finish'}[item.mid_table_remark_007]"
            >
              {{ item.mid_table_remark_007 == 7001 ? "发布中" : (item.mid_table_remark_007 == 7002 ? "已接单" : "已完成") }}
            </div>
            <div class="cell-column project-yusuan-cell">
              <span v-if="item.mid_table_remark_004">{{ item.mid_table_remark_004 }}</span>
              <span v-else>--</span>
            </div>
            <div class="cell-column task-publishtime-cell">
              {{ item.time_insert|showTime }}
            </div>
            <div class="cell-column task-publishtime-cell">
              {{ item.time_4_end|showTime  }}
            </div>
            <div class="cell-column operate-cell">
              <div @click="toTestDemandDetail(item)">查看详情
              </div>
            </div>
          </div>
        </template>
        <NoneData v-else></NoneData>
      </div>
    </template>
  </div>
</template>
<script>
import NoneData from "@/components/NoneData";
import { formatDate } from "@/utils/tool";
import pageCommon from "@/utils/pagecommon";
import taskApi from "@/api/task";
import publicityApi from "@/api/publicity";
import demandCollectApi from "@/api/demandCollect";
import UIDemandApi from "@/api/UIDemand";
import testDemandApi from "@/api/testDemand";
export default {
  name: "TaskCenter",
  components: {
    NoneData,
  },
  created() {
    let _this = this;
    _this.$store.dispatch("acCenterNavIndex", 10);
    _this.currentPage = 1;
    _this.total = 1;
    _this.taskList = [];
    _this.selTabIndex=1301;
    _this.getTaskList();
    _this.disabledLoadMore = true;
  },
  data() {
    return {
      taskList: [],
      currentPage: 1,
      pageSize: 10,
      total: 1,
      disabledLoadMore: false,
      selTabIndex: 1301,
      old_search_value:'',
      search_value:'',
    };
  },
  computed: {
    userInfo: function () {
      let _this = this;
      let user = _this.$store.state.user;
      return user;
    },
  },
  mounted: function () {
    let _this = this;
  },
  filters: {
    showTime: function (val) {
      if (!val) {
        return;
      }
      let time = formatDate(
        new Date(val.replace(/-/g, "/")),
        "YYYY.MM.DD hh:mm:ss"
      );
      return time;
    },
  },
  methods: {
    handleSearch(){
      let _this = this;
      if(_this.search_value!=_this.old_search_value){
        _this.old_search_value=_this.search_value;
        _this.disabledLoadMore = true;
        _this.currentPage=1;
        _this.taskList=[];
        _this.getTaskList();
      }
    },
    handleSelTab: function (idx) {
      let _this = this;
      if (_this.selTabIndex == idx) {
        return;
      }
      _this.selTabIndex = idx;
      _this.disabledLoadMore = true;
      _this.currentPage=1;
      _this.taskList=[];
      _this.getTaskList();
    },
    getDays: function (val) {
      let startDate='';
      let endDate='';
      if(val.time_4_end){
          endDate =  new Date(val.time_4_end.replace(/-/g, "/")).getTime();
      }else if(val.time_insert){
          startDate = new Date(val.time_insert.replace(/-/g, "/"));
          endDate = startDate.setDate(startDate.getDate() + 30);
      }else{
          return '--';
      }
      let currentDate = new Date().getTime();
      let days = (endDate-currentDate) / 1000 / 60 / 60 / 24;
      let daysAfter = days>0?days.toFixed(0):0
      return daysAfter + '天后截止';
    },
    getTaskList: function () {
      let param=this.userInfo.mid_table_remark_020
      let isPublic=param==2002||param==2003||param==2004?true:false;
      let _this = this;
      let requestData = this.selTabIndex==1111 ? 
      {
        begin_idx: (_this.currentPage - 1) * _this.pageSize,
        limit: _this.pageSize,
        pre_db_para_order_by_para: ' data_weight desc ',
        isloading: true,
        mid_table_remark_001:this.search_value,
        mid_table_remark_003: isPublic?'3001,3002':'3001',
      }:( this.selTabIndex==2222 ?
        {
          begin_idx: (_this.currentPage - 1) * _this.pageSize,
          limit: _this.pageSize,
          pre_db_para_order_by_para: ' data_weight desc ',
          isloading: true,
          mid_table_remark_001:this.search_value,
          mid_table_remark_020: '2001,2002,2003',
        }:( this.selTabIndex==3333 ? {
          begin_idx: (_this.currentPage - 1) * _this.pageSize,
          limit: _this.pageSize,
          pre_db_para_order_by_para: ' data_weight desc ',
          isloading: true,
          mid_table_remark_001:this.search_value,
          mid_table_remark_007: '7001,7002,7003',
          is_online:0
        }:( this.selTabIndex==4444 ? {
          begin_idx: (_this.currentPage - 1) * _this.pageSize,
          limit: _this.pageSize,
          pre_db_para_order_by_para: ' data_weight desc ',
          isloading: true,
          mid_table_remark_001:this.search_value,
          mid_table_remark_007: '7001,7002,7003',
          is_online:0
        }:{
          begin_idx: (_this.currentPage - 1) * _this.pageSize,
          limit: _this.pageSize,
          mid_table_remark_001:this.search_value,
          mid_table_remark_013: this.selTabIndex==9999?'1301,1302,1303,1304':this.selTabIndex,
          pre_db_para_order_by_para: ' data_weight desc ',
          isloading: true,
        }))
      );
      var apiObg={
        1111:{
          'api':publicityApi,
          'data':'getPublicityData',
        },
        1301:{
          'api':taskApi,
          'data':'getTaskData',
        },
        2222:{
          'api':demandCollectApi,
          'data':'getDemandCollectData',
        },
        3333:{
          'api':UIDemandApi,
          'data':'getUIDemandData',
        },
        4444:{
          'api':testDemandApi,
          'data':'getTestDemandData',
        },
        9999:{
          'api':taskApi,
          'data':'getTestDemandData',
        }
      };
      pageCommon.apiRequestCommon(apiObg[this.selTabIndex].api, apiObg[this.selTabIndex].data, requestData).then(
        (res) => {
          let taskList = res.page_content;
          // 用concat
          _this.taskList.push(...taskList);
          _this.total = res.result_num;
          if (_this.taskList.length == _this.total) {
            _this.disabledLoadMore = true;
          }else{
            _this.disabledLoadMore = false;
          }
          _this.isRequesting = false;
        },
        (err) => {
          _this.isRequesting = false;
          _this.taskList = [];
          if (err.sysUserLoginError) {
            _this.$message.error("系统异常，请稍后刷新重试！");
          } else {
            _this.$message.error(err.data.msg);
          }
        }
      );
    },
    loadMoreData: function () {
      let _this = this;
      if (_this.isRequesting) {
        return;
      }
      _this.isRequesting = true;
      _this.currentPage += 1;
      _this.getTaskList();
    },
    toTaskDetail: function (item) {
      let _this = this;
      let id = item ? item.id_public_middle_table : "";
      let requestTaskData = {
        isloading: true,
        id_public_user_info: _this.userInfo.id_public_user_info,
        mid_table_remark_007:7002
      };
      if(_this.userInfo.user_remark_018!=1802&&_this.userInfo.user_remark_018!=1803&&_this.userInfo.user_remark_018!=1804){
        _this.$message.error("您还不是认证开发者，请先认证");
        return
      }
      pageCommon.apiRequestCommon(taskApi, "getOfferData", requestTaskData).then(
        (res) => {
          if(res.result_num>0){
            _this.$message.error("您已经有已中标的任务，无法查看详情！");
          }else{
            // 查看限制：已经完成小模式的的不能查看
            if(this.userInfo.user_remark_024==2402){
              _this.$message.error("您已经开发过小模式，请报价征集需求");
              return
            }
            if(item.mid_table_remark_013==1301){
              _this.$router.push({
                path: "/taskCenterDetail",
                query: {
                  id: id
                },
              });
            }
          }
        },
        (err) => {
          _this.sending = false;
          if (err.sysUserLoginError) {
            _this.$message.error("系统异常，请稍后刷新重试！");
          } else {
          }
        }
      );
    },
    toPublicityDetail: function (item) {
      let _this = this;
      let id = item ? item.id_public_middle_table : "";
      _this.$router.push({
        path: "/PublicityCenterDetail",
        query: {
          id: id
        },
      });
    },
    toDemandCollectDetail: function (item) {
      let _this = this;
      let id = item ? item.id_public_middle_table : "";
      if(_this.userInfo.user_remark_018!=1802&&_this.userInfo.user_remark_018!=1803&&_this.userInfo.user_remark_018!=1804){
        _this.$message.error("您还不是认证开发者，请先认证");
        return
      }
      _this.$router.push({
        path: "/DemandCollectDetail",
        query: {
          id: id
        },
      });
    },
    toUIDemandDetail: function (item) {
      let _this = this;
      let id = item ? item.id_public_middle_table : "";
      let requestTaskData = {
        isloading: true,
        id_public_user_info: _this.userInfo.id_public_user_info,
        mid_table_remark_013_in: 1302,
        is_online:0
      };
      // 查看限制：已经完成小模式的的不能查看
      if(this.userInfo.user_remark_025==2502){
        _this.$message.error("您已经参与过UI需求的设计");
        return
      }
      pageCommon.apiRequestCommon(UIDemandApi, "getUIDemandOfferData", requestTaskData).then(
        (res) => {
          if(res.result_num>0){
            _this.$message.error("您已经有已中标的UI需求，无法查看详情！");
          }else{
            if(item.mid_table_remark_007==7001){
              _this.$router.push({
                path: "/UIDemandDetail",
                query: {
                  id: id
                },
              });
            }
          }
        },
        (err) => {
          _this.sending = false;
          if (err.sysUserLoginError) {
            _this.$message.error("系统异常，请稍后刷新重试！");
          } else {
          }
        }
      );
    },
    toTestDemandDetail: function (item) {
      let _this = this;
      let id = item ? item.id_public_middle_table : "";
      let requestTaskData = {
        isloading: true,
        id_public_user_info: _this.userInfo.id_public_user_info,
        mid_table_remark_013_in: 1302,
        is_online:0
      };
      if(_this.userInfo.user_remark_028!=2802){
        _this.$message.error("您还未通过测试认证，请先认证");
        return
      }
      pageCommon.apiRequestCommon(testDemandApi, "getTestDemandOfferData", requestTaskData).then(
        (res) => {
          if(res.result_num>0){
            _this.$message.error("您已经有已中标的测试需求，无法查看详情！");
          }else{
            if(item.mid_table_remark_007==7001){
              _this.$router.push({
                path: "/TestDemandDetail",
                query: {
                  id: id
                },
              });
            }
          }
        },
        (err) => {
          _this.sending = false;
          if (err.sysUserLoginError) {
            _this.$message.error("系统异常，请稍后刷新重试！");
          } else {
          }
        }
      );
    },
  },
};
</script>
<style lang="less" scoped>
@import "../../assets/css/common.less";
@import "../../assets/css/center.less";
.mytask {
  position: relative;
  width: 100%;
  // height: 100%;
  height: 1131px;
  padding-left: 40px;
  padding-right: 40px;
  box-sizing: border-box;
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  .page-title {
    position: relative;
    display: flex;
    display: -webkit-flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    .page-title-wrap{
      display: flex;
      flex-direction: row;
    }
    .search-wrap{
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      margin-left:24px;
      width: 312px;
      height: 36px;
      padding: 0 0 0 13px;
      border: 1px solid #EAEAEA;
      border-radius: 4px;
      .icon-text{
        display:block;
        width:270px;
        height:36px;
        line-height:1.2em;
        font-size:.69rem;
        border:none;
        background:transparent;
        outline: none;
        &::placeholder{
          color:#AAA;
        }
      }
      .icon-serch{
        display: block;
        width:36px;
        height:36px;
        background-size:44.44%;
        background-position:center;
        background-repeat:no-repeat;
        background-image:url(~@/assets/icon_search.png);
      }
    }
  }
  .nav-tabpanel-box {
    position: relative;
    width: 100%;
    display: flex;
    display: -webkit-flex;
    flex-direction: row;
    border-bottom: 1px solid #eeeeee;
    box-sizing: border-box;
    margin-top: 40px;
    .item-nav-box {
      position: relative;
      height: 32px;
      font-size: 18px;
      font-family: Source Han Sans CN;
      color: #222222;
      line-height: 18px;
      box-sizing: border-box;
      cursor: pointer;
      margin-right: 64px;
      &.active {
        color: #ec4040;
        font-weight: bold;
        &::after {
          position: absolute;
          width: 100%;
          content: "";
          height: 4px;
          background: #ec4040;
          left: 0;
          bottom: 0;
        }
      }
    }
  }
  .cell-row {
    position: relative;
    width: 100%;
    box-sizing: border-box;
    display: flex;
    display: -webkit-flex;
    flex-direction: row;
    align-items: center;
    padding-left: 25px;
    padding-right: 25px;
    box-sizing: border-box;
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #666666;
    line-height: 16px;
    text-align: left;
  }
  .cell-column {
    position: relative;
    text-align: left;
    flex-shrink: 0;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
  }
  .tasktype-cell {
    position: relative;
    width:20%;
  }
  .taskname-cell{
    position: relative;
    width:25%;
  }
  .taskpost-cell,.tasktime-cell,.tasktime-cell,.taskstatus-cell{
    position: relative;
    width:25%;
    text-align:center;
  }
  .projecttype-cell {
    position: relative;
    width: 20%;
    text-align: center;
  }
  .project-yusuan-cell {
    position: relative;
    width: 15%;
    text-align: center;
  }
  .task-publishtime-cell {
    position: relative;
    width: 20%;
    text-align: center;
  }
  .task-days-cell{
    position: relative;
    width: 15%;
    text-align: center;
  }
  .operate-cell {
    position: relative;
    width: 10%;
    text-align: center;
  }
  .table-header-box {
    position: relative;
    height: 60px;
    background: #f4f4f4;
    border: 1px solid #eaeaea;
    border-radius: 4px;
    box-sizing: border-box;
    box-sizing: border-box;
    margin-top: 35px;
    margin-bottom: 24px;
    .status-cell {
      text-align: center;
    }
    .creattime-cell {
      text-align: center;
    }
  }
  .table-list-box {
    position: relative;
    flex: 1;
    width: 100%;
    margin-bottom: 24px;
    overflow: hidden;
    overflow-y: auto;
    &::-webkit-scrollbar {
      display: none;
    }
  }
  .datalist-row {
    height: 100px;
    background: #ffffff;
    border: 1px solid #eaeaea;
    border-radius: 4px;
    box-sizing: border-box;
    margin-bottom: 24px;
    &:nth-child(2n) {
      background: #f6f6f6;
    }
    &:last-child {
      margin-bottom: 0;
    }
    .cell-column {
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #000000;
      &.ongoing{
        color: #0072ff;
      }
      &.getoffer{
        color: #ff9e13;
      }
      &.pushoffer{
        color: #aaa;
      }
      &.finish{
        color: #208227;
      }
    }
    .operate-cell {
      position: relative;
      display: flex;
      display: -webkit-flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #ec4040;
      line-height: 16px;
      div {
        cursor: pointer;
      }
      .diabled {
        color: #ffa8a8;
        cursor: auto;
      }
    }
    .projecttype-cell,
    .project-yusuan-cell,
    .demand-status-cell,
    .demand-publishtime-cell {
      text-align: center;
    }
    .white-cell {
      text-align: center;
    }
  }
}
</style>
